import React from 'react';
import { CheckCircle, XCircle } from '@phosphor-icons/react';

/**
 * Password strength indicator matching backend policy.
 * Rules (kept in sync with /app/backend/password_policy.py):
 *  - min 8 chars
 *  - at least 1 uppercase
 *  - at least 1 lowercase
 *  - at least 1 number
 */
export const validatePassword = (password) => {
  const checks = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
  };
  const isValid = Object.values(checks).every(Boolean);
  return { checks, isValid };
};

const requirements = [
  { key: 'length', label: 'Almeno 8 caratteri' },
  { key: 'uppercase', label: 'Almeno una lettera maiuscola' },
  { key: 'lowercase', label: 'Almeno una lettera minuscola' },
  { key: 'number', label: 'Almeno un numero' },
];

const PasswordStrengthIndicator = ({ password }) => {
  const { checks } = validatePassword(password || '');

  return (
    <ul className="space-y-1 mt-2" data-testid="password-requirements">
      {requirements.map((req) => {
        const passed = checks[req.key];
        return (
          <li
            key={req.key}
            className={`flex items-center gap-2 text-xs ${passed ? 'text-primary' : 'text-foreground/60'}`}
            data-testid={`req-${req.key}-${passed ? 'ok' : 'fail'}`}
          >
            {passed ? (
              <CheckCircle size={14} weight="fill" />
            ) : (
              <XCircle size={14} weight="regular" />
            )}
            <span>{req.label}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordStrengthIndicator;
